import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import Typography from '../components/Typography';

const item = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: { xs: 1, sm: 5 },
};

const values = {
  en: {
    1: 'Exceptional Comfort',
    2: 'At S Princess Suite, we are dedicated to providing an exceptional level of comfort to our guests. We believe that a comfortable stay is the foundation of a memorable experience.',
    3: 'Personalized Service',
    4: 'Our commitment to personalized service sets us apart. We understand that each guest is unique, and we strive to cater to your individual needs and preferences. We are here to make your stay truly special.',
    5: 'PRIME LOCATION',
    6: 'S Princess Suite is ideally situated just 20 meters from the Aegean Sea in Nea Kallikratia, Chalkidiki. Our prime waterfront location offers direct access to pristine beaches, stunning sunsets, and various water activities, ensuring an unforgettable coastal getaway',
  },

  el: {
    1: 'Εξαιρετική Άνεση',
    2: 'Στο S Princess Suite, αφιερώνουμε ιδιαίτερη προσοχή στην παροχή υψηλού επιπέδου άνεσης στους επισκέπτες μας. Πιστεύουμε ότι μια άνετη διαμονή αποτελεί τη βάση για μια αξέχαστη εμπειρία.',
    3: 'Εξατομικευμένη Εξυπηρέτηση',
    4: 'Η δέσμευσή μας στην εξατομικευμένη εξυπηρέτηση μας ξεχωρίζει. Κατανοούμε ότι κάθε επισκέπτης είναι μοναδικός και φροντίζουμε να καλύπτουμε τις προσωπικές σας ανάγκες και προτιμήσεις.',
    5: 'ΠΡΟΝΟΜΙΑΚΗ ΤΟΠΟΘΕΣΙΑ',
    6: 'Το S Princess Suite βρίσκεται μόλις 20 μέτρα από το Αιγαίο Πέλαγος στη Νέα Καλλικράτεια Χαλκιδικής, προσφέροντας άμεση πρόσβαση σε παραλίες, εντυπωσιακά ηλιοβασιλέματα και θαλάσσιες δραστηριότητες.',
  },

  de: {
    1: 'Außergewöhnlicher Komfort',
    2: 'Im S Princess Suite legen wir größten Wert auf außergewöhnlichen Komfort für unsere Gäste. Wir sind überzeugt, dass ein angenehmer Aufenthalt die Grundlage für ein unvergessliches Erlebnis ist.',
    3: 'Personalisierter Service',
    4: 'Unser Anspruch an einen persönlichen Service hebt uns hervor. Jeder Gast ist einzigartig, und wir passen unsere Leistungen individuell an Ihre Wünsche und Bedürfnisse an.',
    5: 'ERSTKLASSIGE LAGE',
    6: 'Das S Princess Suite liegt nur 20 Meter vom Ägäischen Meer in Nea Kallikratia, Chalkidiki, entfernt und bietet direkten Zugang zu traumhaften Stränden, atemberaubenden Sonnenuntergängen und zahlreichen Wassersportmöglichkeiten.',
  },

  fr: {
    1: 'Confort Exceptionnel',
    2: 'Au S Princess Suite, nous nous engageons à offrir à nos clients un niveau de confort exceptionnel. Nous croyons qu’un séjour confortable est la base d’une expérience inoubliable.',
    3: 'Service Personnalisé',
    4: 'Notre engagement envers un service personnalisé nous distingue. Chaque client est unique, et nous adaptons nos services à vos besoins et préférences.',
    5: 'EMPLACEMENT PRIVILÉGIÉ',
    6: 'Le S Princess Suite est idéalement situé à seulement 20 mètres de la mer Égée à Nea Kallikratia, en Chalcidique, offrant un accès direct aux plages, aux magnifiques couchers de soleil et aux activités nautiques.',
  },

  ro: {
    1: 'Confort Excepțional',
    2: 'La S Princess Suite, ne dedicăm oferirii unui nivel excepțional de confort oaspeților noștri. Credem că un sejur confortabil este baza unei experiențe memorabile.',
    3: 'Servicii Personalizate',
    4: 'Angajamentul nostru față de serviciile personalizate ne diferențiază. Fiecare oaspete este unic, iar noi ne adaptăm nevoilor și preferințelor dumneavoastră.',
    5: 'LOCAȚIE PREMIUM',
    6: 'S Princess Suite este situat ideal la doar 20 de metri de Marea Egee, în Nea Kallikratia, Halkidiki, oferind acces direct la plaje curate, apusuri spectaculoase și activități nautice.',
  },

  bg: {
    1: 'Изключителен Комфорт',
    2: 'В S Princess Suite сме посветени на това да осигурим изключително ниво на комфорт за нашите гости. Вярваме, че удобният престой е основата на незабравимо преживяване.',
    3: 'Персонализирано Обслужване',
    4: 'Нашият ангажимент към персонализираното обслужване ни отличава. Всеки гост е уникален и ние се стремим да отговорим на вашите индивидуални нужди.',
    5: 'ПРЕМИУМ ЛОКАЦИЯ',
    6: 'S Princess Suite се намира само на 20 метра от Егейско море в Неа Каликратия, Халкидики, с директен достъп до плажове, красиви залези и водни активности.',
  },

  mk: {
    1: 'Исклучителна Удобност',
    2: 'Во S Princess Suite сме посветени на обезбедување исклучително ниво на удобност за нашите гости. Веруваме дека удобниот престој е основа за незаборавно искуство.',
    3: 'Персонализирана Услуга',
    4: 'Нашата посветеност на персонализирана услуга нè издвојува. Секој гостин е единствен и ние внимателно се прилагодуваме на вашите потреби.',
    5: 'ПРЕМИУМ ЛОКАЦИЈА',
    6: 'S Princess Suite е идеално лоциран само 20 метри од Егејското Море во Неа Каликратија, Халкидики, со директен пристап до плажи, зајдисонца и водени активности.',
  },

  sr: {
    1: 'Изузетна Удобност',
    2: 'У S Princess Suite-у посвећени смо пружању изузетног нивоа удобности нашим гостима. Верујемо да је удобан боравак основа незаборавног искуства.',
    3: 'Персонализована Услуга',
    4: 'Наша посвећеност персонализованој услузи нас издваја. Сваки гост је јединствен и ми се прилагођавамо вашим индивидуалним потребама.',
    5: 'ПРЕМИЈУМ ЛОКАЦИЈА',
    6: 'S Princess Suite се налази само 20 метара од Егејског мора у Неа Каликратији, Халкидики, нудећи директан приступ плажама, заласцима сунца и воденим активностима.',
  },

  ru: {
    1: 'Исключительный Комфорт',
    2: 'В S Princess Suite мы стремимся обеспечить нашим гостям исключительный уровень комфорта. Мы уверены, что комфортное проживание является основой незабываемого отдыха.',
    3: 'Персональный Сервис',
    4: 'Наше внимание к персональному сервису отличает нас. Каждый гость уникален, и мы стараемся учитывать ваши индивидуальные потребности.',
    5: 'ПРЕМИАЛЬНОЕ РАСПОЛОЖЕНИЕ',
    6: 'S Princess Suite расположен всего в 20 метрах от Эгейского моря в Неа Калликратии, Халкидики, с прямым доступом к пляжам, живописным закатам и водным развлечениям.',
  },

  uk: {
    1: 'Винятковий Комфорт',
    2: 'У S Princess Suite ми прагнемо забезпечити нашим гостям винятковий рівень комфорту. Ми віримо, що зручне проживання є основою незабутніх вражень.',
    3: 'Персоналізований Сервіс',
    4: 'Наш підхід до персоналізованого сервісу вирізняє нас. Кожен гість унікальний, і ми враховуємо ваші індивідуальні потреби.',
    5: 'ПРЕМІАЛЬНЕ РОЗТАШУВАННЯ',
    6: 'S Princess Suite розташований лише за 20 метрів від Егейського моря в Неа Каллікратії, Халкідіки, з прямим доступом до пляжів, мальовничих заходів сонця та водних розваг.',
  },
};

function ProductValues() {
  const { i18n } = useTranslation();
  const lang = i18n.language.split('-')[0];
  const content = values[lang] || values.en;

  return (
    <Box
      component="section"
      sx={{ display: 'flex', overflow: 'hidden', bgcolor: 'secondary.light' }}
    >
      <Container
        sx={{
          mt: { xs: 6, sm: 15 },
          mb: { xs: 8, sm: 30 },
          display: 'flex',
          position: 'relative',
          px: { xs: 2, sm: 3 },
        }}
      >
        <Grid container spacing={{ xs: 4, sm: 5 }}>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <Box
                component="img"
                src="/icons/comfort.png"
                alt="comfort"
                width={55}
                height={55}
                loading="lazy"
              />
              <Typography variant="h6" sx={{ my: { xs: 2, sm: 5 } }}>
                {content['1']}
              </Typography>
              <Typography
                variant="h5"
                fontSize={16}
                sx={{ lineHeight: 1.55, textAlign: 'center' }}
              >
                {content['2']}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <Box
                component="img"
                src="/icons/service.png"
                alt="personalised service"
                width={55}
                height={55}
                loading="lazy"
              />
              <Typography variant="h6" sx={{ my: { xs: 2, sm: 5 } }}>
                {content['3']}
              </Typography>
              <Typography
                variant="h5"
                fontSize={16}
                sx={{ lineHeight: 1.55, textAlign: 'center' }}
              >
                {content['4']}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <Box
                component="img"
                src="/icons/location.png"
                alt="location"
                width={55}
                height={55}
                loading="lazy"
              />
              <Typography variant="h6" sx={{ my: { xs: 2, sm: 5 } }}>
                {content['5']}
              </Typography>
              <Typography
                variant="h5"
                fontSize={16}
                sx={{ lineHeight: 1.55, textAlign: 'center' }}
              >
                {content['6']}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ProductValues;
